import { Alert, Box, Spinner } from '@amzn/awsui-components-react';
import { useTranslation } from 'react-i18next';
import { useLocale } from '../../../hooks/locale';
import { SaveStatus, SAVE_STATUS_SAVING, SAVE_STATUS_ERROR } from '../../../utils/constants';

interface AutoSaveStatusProps {
  saveStatus: SaveStatus;
  lastSavedTime: Date | null;
}

function formatTime(date: Date, locale: string): string {
  return date.toLocaleTimeString(locale, { hour: 'numeric', minute: '2-digit' });
}

export function AutoSaveStatusLabel({ saveStatus, lastSavedTime }: AutoSaveStatusProps) {
  const { t } = useTranslation(['events']);
  const locale = useLocale();

  if (saveStatus === SAVE_STATUS_SAVING) {
    return (
      <Box color="text-status-inactive" data-testid="auto-save-saving">
        <Spinner size="normal" /> {t('autoSave.saving')}
      </Box>
    );
  }

  if (lastSavedTime) {
    return (
      <Box color="text-status-inactive" data-testid="auto-save-saved">
        {t('autoSave.lastSave', { time: formatTime(lastSavedTime, locale) })}
      </Box>
    );
  }

  return null;
}

export function AutoSaveErrorAlert({ saveStatus }: Pick<AutoSaveStatusProps, 'saveStatus'>) {
  const { t } = useTranslation(['events']);

  if (saveStatus !== SAVE_STATUS_ERROR) return null;

  return (
    <Alert type="error" header={t('autoSave.draftNotSavedHeader')} data-testid="auto-save-error">
      {t('autoSave.draftNotSavedDescription')}
    </Alert>
  );
}
